import React from 'react';
import { useUserContext } from '../../contexts/user-context';
import WaitSpinner from '../../components/wait-spinner';
import { TwoFactorLogin } from '../../components/two-factor-login';
import { TwoFactorPrompt } from '../../components/two-factor-prompt';
import Login from '../../components/login';
import { useRespondToCampaignChallengeMutation, useGetCampaignChallengeQuery } from '../../generated/graphql';
import { useParams } from 'react-router-dom';
import { Alert, AppBar, Button, Card, CardContent, CardHeader, Checkbox, Container, FormControlLabel, List, ListItem, ListItemIcon, ListItemText, Toolbar, Typography, useTheme } from '@mui/material';
import { NonIdealState } from '../../components/NonIdealState';
import { useState } from 'react';
import { useCallback } from 'react';
import { isoDateToMMM } from '../../utils/index';

const CampaignChallengeAcceptance = function () {
    const userContext = useUserContext();
    const params = useParams();
    const theme = useTheme();
    const [releaseThese, setReleaseThese] = useState({});
    const [lastMutationResponse, setLastMutationResponse] = useState<any>();
    const campaignQuery = useGetCampaignChallengeQuery({ variables: { id: params.ref }, skip: !userContext?.isLoggedIn });
    const [respondMutation] = useRespondToCampaignChallengeMutation();
    const toggleReleaseThese = useCallback((key, status) => {
        setReleaseThese((state) => {
            if (state[key] && state[key] == status) {
                delete state[key];
            } else {
                state[key] = status;
            }
            return { ...state };
        });
    }, []);
    if (userContext?.isLoggedIn === null) {
        return <WaitSpinner variant="overlay" />;
    }
    if (userContext?.isError) {
        if (userContext.errorMessage == '2FA-REQUIRED') {
            return <TwoFactorLogin />;
        }
        if (userContext.errorMessage == '2FA-REGISTER-REQUIRED') {
            //if(!userContext.hasAuthenticatorCode) {
            return <TwoFactorPrompt />;
            //}
        }
        return <Login />;
    }

    if (!userContext || !userContext.isLoggedIn) {
        return <Login />;
    }
    if (campaignQuery.loading) {
        return <WaitSpinner variant="panel" />;
    }
    if (!campaignQuery.data || !campaignQuery.data?.getCampaignChallenge) {
        return <NonIdealState sx={{ position: "absolute", top: "50%", left: 0, right: 0, transform: "translate(0,-50%)" }} severity="error" title="An error has occurred" message="Unable to fetch campaign" />
    }
    const showBookings:JSX.Element[] = [];

    const hasRelease = (key, status) => {
        return !!(releaseThese[key] && releaseThese[key] == status);
    }
    const doRelease = () => {
        const input = { id: campaignQuery?.data?.getCampaignChallenge?.id, responses: [] };
        Object.keys(releaseThese).forEach(key => {
            input.responses.push({ id: key, status: releaseThese[key] });
        });
        respondMutation({ variables: { input: input } }).then(response => {
            setLastMutationResponse(response?.data?.respondToCampaignChallenge);
            campaignQuery.refetch();
        });
    }
    const filteredChallenges = [];
    // filter rows
    // use the query from generating the campaign email
    campaignQuery.data?.getCampaignChallenge?.bookingChallenges?.forEach((panelChallenge) => {
        const panelBooking = panelChallenge?.targetPanelBooking;
        const targetCampaign = panelChallenge?.targetCampaign;
        if (panelChallenge?.status != 'OPEN') return;
        if(panelChallenge.targetCampaign?.ourContact?.id != userContext?.user?.id &&
            panelChallenge.targetCampaign?.ourContact?.proxyUser?.id != userContext?.user?.id) return;
        showBookings.push(<ListItem key={panelChallenge?.id}>
            <ListItemIcon>
                <FormControlLabel onChange={() => { toggleReleaseThese(panelChallenge?.id, 'RELEASE') }} control={<Checkbox edge="start" checked={hasRelease(panelChallenge?.id, 'RELEASE')} disableRipple />} label="RELEASE" />
            </ListItemIcon>
            <ListItemIcon>
                <FormControlLabel onChange={() => {
                    toggleReleaseThese(panelChallenge?.id, 'REJECT')
                }} control={<Checkbox edge="start" checked={hasRelease(panelChallenge?.id, 'REJECT')} disableRipple />} label="REJECT" />
            </ListItemIcon>
            <ListItemText><b>[{targetCampaign?.job_reference}] {targetCampaign?.name}</b><br />
                {panelBooking?.panel?.site?.name} <br />
                <span>{isoDateToMMM(panelChallenge?.date_start)} -
                    {isoDateToMMM(panelChallenge?.date_end)}</span></ListItemText>
        </ListItem>);
    });

    return <div>
        <AppBar position="sticky">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <img style={{ cursor: "pointer" }} alt="" src={theme?.components?.Daybook?.defaultProps?.logo} />
                </Toolbar>
            </Container>
        </AppBar>
        <Container maxWidth="xl">
            <Card sx={{ overflowY: 'auto' }} className="is-scrollable" variant="elevation">
                <CardHeader title={campaignQuery.data?.getCampaignChallenge?.campaign?.job_reference + ' / ' + campaignQuery.data?.getCampaignChallenge?.campaign?.name+' / '+campaignQuery.data?.getCampaignChallenge?.campaign?.ourContact?.name} />
                <CardContent>
                    {lastMutationResponse != null && <>
                        <Alert severity="success">The response has been posted.</Alert>
                    </>
                    }
                    {showBookings.length <= 0 && <>
                        <Alert severity="success">There are no outstanding requests for your campaigns!</Alert>
                    </>
                    }
                    {showBookings.length > 0 &&
                        <>
                            <List sx={{ paddingBottom: '80px' }}>{showBookings}</List>
                        </>
                    }
                </CardContent>
            </Card>
        </Container>
        <AppBar position="fixed" sx={{ top: 'auto', bottom: 0 }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters style={{ justifyContent: 'flex-end' }}>
                    {showBookings.length > 0 &&
                        <Button size="large" variant="contained" color="success" onClick={doRelease}>Respond</Button>
                    }
                </Toolbar></Container>
        </AppBar>
    </div>;
}

export default CampaignChallengeAcceptance;